import { Heading, useTheme } from '@aws-amplify/ui-react';
import { Alert } from '@mui/material';
import * as React from 'react';

import { clearAdminLoginError, readAdminLoginError } from './services';

const SignIn = {
  Header: () => {
    const { tokens } = useTheme();
    const [adminLoginError, setAdminLoginError] = React.useState(readAdminLoginError);

    const dismiss = () => {
      clearAdminLoginError();
      setAdminLoginError('');
    };

    return (
      <>
        <Heading
          padding={`${tokens.space.xl} ${tokens.space.xl} 0 ${tokens.space.xl}`}
          level={3}
          textAlign="center"
        >
          Admin Login
        </Heading>
        {adminLoginError && (
          <Alert severity="error" onClose={dismiss} sx={{ mx: 4, mt: 2 }}>
            {adminLoginError}
          </Alert>
        )}
      </>
    );
  },
};

export default SignIn;
